import { Fetch } from '@polvo-labs/react-auth'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/Button'
import Loader from '../../../components/Loader'
import Pagination from '../../../components/Pagination'
import Private from '../../../components/Private'
import RealtyList from '../../../components/Realty/List'
import Text from '../../../components/Text'
import routes from '../../../config/routes'
import RealtyType from '../../../models/Realty'
import ActivateScreen from '../../Activate/Resend'
import { RouteProps } from 'react-router-dom'

type Props = RouteProps

const RealtyListScreen: React.FC<Props> = (props) => {
  const search = props.location?.search ?? ''
  const isCreated = search.includes('created')
  const [apiUrl, setApiUrl] = useState(`${process.env.REACT_APP_API_URL}/realties`)
  const history = useHistory()

  return (
    <Private>
      <div>
        {(isCreated ? (
          <p
            style={
              {fontFamily: 'Roboto',
                fontSize: '16px',
                lineHeight: '19px',
                textAlign: 'left',
                color: '#9a9a9a',
                backgroundColor: '#cfe2ff',
                padding: '1rem 1rem',
                marginBottom: '1rem',
                border: '1px solid transparent',
                borderRadius: '.25rem',
                borderColor: '#b6d4fe'}
            }
          >
          As suas informações estão sendo analisadas e caso haja possibilidade, entraremos em contato para a formalização de uma proposta de compra do imóvel.
          Em caso de dúvidas, entre em contato conosco no <a
              href = "mailto: iptu@iptu.app"
          >iptu@iptu.app</a>.
          </p>) : '')
        }
        <Text
          tag="h1"
        >
          Meus imóveis
        </Text>

        <Fetch
          url={apiUrl}
          loader={() => (
            <Loader
              darkMode
            />
          )}
        >
          {({ data }) => data && data.data ? (
            <>
              <RealtyList
                realties={data.data as RealtyType[]}
                emptyAction={(
                  <Button
                    label="Cadastrar imóvel com dívida"
                    onClick={() => history.push(routes.realty.create.path)}
                  />
                )}
                action={(realty: RealtyType) => (
                  <Button
                    label="Mais detalhes"
                    backgroundColor="blue"
                    block
                    onClick={() => {
                      history.push(routes.realty.edit.pathFor(realty.id))
                    }}
                  />
                )}
              />

              <Pagination
                meta={data.meta}
                links={data.links}
                onChange={setApiUrl}
              />
            </>
          ) : (
            <ActivateScreen/>
            // <span>
            //   Error
            // </span>
          )}
        </Fetch>
      </div>
    </Private>
  )
}

export default RealtyListScreen
